﻿<script setup lang="ts">
    import anonymizationManager from '@cwd/Account/AnonymizationManager.vue';
    import mergeContactManager from '@cwd/Account/MergeContactManager.vue';
    import Tabs, { tab } from '@shared/components/Tabs.vue';
    import { $Resources } from '@cwd/lib/main';
</script>

<script lang="ts">
    export default {
        name: 'DataManagement',
    };
</script>

<template>
    <h2 class="main-title">{{ $Resources.DataManagementHeading }}</h2>
    <tabs>
        <tab :title="$Resources.DataManagementTabInactiveContactsLabel">
            <anonymization-manager></anonymization-manager>
        </tab>

        <tab :title="$Resources.DataManagementTabMergeContactsLabel">
            <merge-contact-manager></merge-contact-manager>
        </tab>
    </tabs>
</template>

<style scoped></style>
